import React from 'react'
import GooglePlayIcon from '../../assets/icons/playStores/GooglePlayIcon'
import styled from 'styled-components'
import Responsive from '../../assets/config/Responsive'

const PlayStoreButton: React.FC<{ appId: string; style?: React.CSSProperties }> = ({ appId, style }) => {
  const playStoreUrl = `https://play.google.com/store/apps/details?id=${appId}`

  return (
    <ATag style={style} href={playStoreUrl} target="_blank" rel="noopener noreferrer">
      <GooglePlayIcon />
    </ATag>
  )
}

const ATag = styled.a`
  &:hover {
    box-shadow: 0px 0px 15px 1px rgba(0, 0, 0, 0.02);
    -webkit-box-shadow: 0px 0px 15px 1px rgba(0, 0, 0, 0.02);
    -moz-box-shadow: 0px 0px 15px 1px rgba(0, 0, 0, 0.02);
  }

  ${Responsive.mobile} {
    min-width: 150px;

    svg {
      width: 100%;
    }
  }
`

export default PlayStoreButton
